import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '@/core/utils/cn';
export const Select = forwardRef(({ className, error, children, ...props }, ref) => (_jsx("select", { ref: ref, className: cn('flex h-10 w-full rounded-md border bg-surface px-3 pr-8 text-sm', 'focus-visible:outline-none focus-visible:border-primary', 'disabled:cursor-not-allowed disabled:opacity-60', error ? 'border-danger' : 'border-border', className), ...props, children: children })));
Select.displayName = 'Select';
